import React from 'react';
import './OptionSelector.css';

export interface OptionSelectorOption {
    value: string;
    label: string;
    description?: string;
}

interface OptionSelectorProps {
    name: string;
    options: OptionSelectorOption[];
    selectedValue: string;
    onChange: (value: string) => void;
    required?: boolean;
    disabled?: boolean;
}

const OptionSelector: React.FC<OptionSelectorProps> = ({
    name,
    options,
    selectedValue,
    onChange,
    required = false,
    disabled = false
}) => {
    const handleChange = (value: string) => {
        if (!disabled) {
            onChange(value);
        }
    };

    return (
        <div className={`option-selector ${disabled ? 'disabled' : ''}`}>
            {options.map((option) => (
                <div key={option.value} className="option-item">
                    <input
                        type="radio"
                        id={`${name}_${option.value}`}
                        name={name}
                        value={option.value}
                        checked={selectedValue === option.value}
                        onChange={() => handleChange(option.value)}
                        required={required}
                        disabled={disabled}
                    />
                    <label htmlFor={`${name}_${option.value}`}>
                        <div className="option-content">
                            <div className="option-icon"></div>
                            <div className="option-text">{option.label}</div>
                            {option.description && (
                                <div className="option-info">
                                    <i className="fas fa-info-circle"></i>
                                </div>
                            )}
                        </div>
                    </label>
                </div>
            ))}
        </div>
    );
};

export default OptionSelector;

